const Auth = {
  login: '/auth/admin/login',
  reset: '/user/reset/password',
  logout: '/auth/logout',
}

export default Auth;